import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-copy-to-clipboard-cell-renderer',
    templateUrl: './copy-to-clipboard-cell-renderer.component.html',
    styleUrl: './copy-to-clipboard-cell-renderer.component.scss'
})

export class CopyToClipboardCellRendererComponent implements ICellRendererAngularComp {

    public value!: string;
    public copied = false;
    private timeoutId?: number;

    public agInit(params: any): void {
        this.value = params.value;
    }

    public refresh(): boolean {
        return false;
    }

    public copy(): void {
        if (!this.value) return;

        navigator.clipboard.writeText(this.value).then(() => {
            this.copied = true;

            if (this.timeoutId) {
                clearTimeout(this.timeoutId);
            }

            this.timeoutId = window.setTimeout(() => {
                this.copied = false;
            }, 1500);
        });
    }
}
